const Milestones = ({ attributes }) => {
    const { milestones } = attributes;

    return (
        <div className="gmf-page-wrapper">
            {/* Page Title */}
            <section className="gmf-page-hero">
                <div className="gmf-page-hero-inner">
                    <p className="gmf-page-eyebrow gmf-accent-color">{milestones.subtitle}</p>
                    <h1 className="gmf-page-title">{milestones.title}</h1>
                    <div className="gmf-divider gmf-divider--center" />
                    <p className="gmf-page-subtitle">
                        {milestones.intro ||
                            'GMF Securities Ltd. is a Member of Dhaka Stock Exchange PLC. bearing Membership no. 186, duly registered with the Bangladesh Securities and Exchange Commission as Stock Dealer & Stockbroker.'}
                    </p>
                </div>
            </section>

            {/* Timeline */}
            <section className="gmf-timeline-section">
                <div className="gmf-timeline">
                    <div className="gmf-timeline-line" />
                    {milestones.items.map((item, index) => (
                        <div
                            key={index}
                            className={`gmf-timeline-item ${index % 2 === 0 ? 'gmf-timeline-item--left' : 'gmf-timeline-item--right'}`}
                        >
                            <div className="gmf-timeline-dot" />
                            <div className="gmf-timeline-card gmf-card">
                                <div className="gmf-timeline-year gmf-step-number">{item.year}</div>
                                <h3 className="gmf-timeline-title">{item.title}</h3>
                                <p className="gmf-timeline-desc">{item.description}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </section>
        </div>
    );
};

export default Milestones;
